<template>
  <v-row>
    <v-col
      v-for="action in actions"
      :key="action.label"
      cols="6"
      sm="3"
    >
      <v-card
        flat
        hover
        class="quick-action-card text-center pa-4"
        :style="{ 'border-color': action.color }"
        @click="$emit('navigate', action.route)"
      >
        <v-icon
          :color="action.color"
          :style="{ 'background-color': action.colorLight }"
          large
          class="icon-circle mb-3"
        >
          {{ action.icon }}
        </v-icon>
        <div class="text-subtitle-2 font-weight-bold">{{ action.label }}</div>
        <div class="text-caption text--secondary">{{ action.description }}</div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DashboardQuickActions",
  data: () => ({
    actions: [
      {
        label: "Ask Sage",
        description: "AI-powered talent search",
        icon: "mdi-robot-outline",
        color: "#7c3aed",
        colorLight: "#ede9fe",
        route: "/Company/Intelligence/SageHR",
      },
      {
        label: "Search Talent",
        description: "Find the right people",
        icon: "mdi-magnify",
        color: "#2b7fff",
        colorLight: "#dfecff",
        route: "/Company/Intelligence/FindTalent?tab=search",
      },
      {
        label: "Match JD",
        description: "Rank candidates by fit",
        icon: "mdi-file-document-check-outline",
        color: "#00c950",
        colorLight: "#d1ffe3",
        route: "/Company/Intelligence/FindTalent?tab=jdmatch",
      },
      {
        label: "Build Team",
        description: "Assemble multi-role teams",
        icon: "mdi-account-group-outline",
        color: "#ff6900",
        colorLight: "#ffe9d9",
        route: "/Company/Intelligence/TeamBuilder",
      },
    ],
  }),
};
</script>

<style scoped>
.quick-action-card {
  border-style: solid;
  border-width: 2px;
  border-radius: 12px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.quick-action-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.icon-circle {
  border-radius: 50%;
  padding: 12px;
}
</style>
